/** Accessory Tile [START] **/
if($(".multiple-swiper").length){
  if (window.innerWidth < 768) {
    hp.swipers = hp.swipers || {};
    var multiple_swiper = 
    {
      initialized: false
    };
  
    multiple_swiper.init = function(){
      var accessoryTile = [];
      var props = [];
      var accessoryTileProps = {
        pagination: {
          el: '.accessory-tile-pagination',
          type: 'bullets',
          clickable: true,
        },
        slidesPerView: 4,
        spaceBetween: 0,
        loop: false,
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 0
          },
          767: {
            slidesPerView: 1,
            spaceBetween: 0
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 0
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 0
          }
        }
      }
      var accessoryTileMethods = {
		    swiperEvents: [{
	        eventName: "slideChangeTransitionEnd",
	        eventMethod: function () {
						hp.modifyAriaLabel()
						hp.hideMobileSlidesNotInView()
						window.focusHeading && window.focusHeading.focus()
	        }
	      }]
	    }
      multiple_swiper.instances = hp.swiperInstance('.multiple-swiper', accessoryTileProps, accessoryTileMethods);
      multiple_swiper.initialized = true;
    }//init END
    hp.swipers.multiple_swiper=multiple_swiper;
  }
}
/** Accessory Tile [END] **/